export default __webpack_public_path__ + "static/media/amazon.32863643.PNG";